// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"261":"80659696","438":"aebeac0b"}[chunkId] + ".chunk.css";
};